import { render } from "./EditorResizeImageMenu.vue?vue&type=template&id=4f79bbf6&scoped=true"
import script from "./EditorResizeImageMenu.vue?vue&type=script&lang=js"
export * from "./EditorResizeImageMenu.vue?vue&type=script&lang=js"

import "./EditorResizeImageMenu.vue?vue&type=style&index=0&id=4f79bbf6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f79bbf6"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QBtn,QTooltip,QItem,QInput});
